import {
  Component,
  forwardRef,
  Inject,
  Input,
  OnDestroy,
  OnInit
}                           from '@angular/core';
import { NgbActiveModal }   from '@ng-bootstrap/ng-bootstrap';
import { Subscription }     from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

import { HaynesProCategoryModel }      from '../typings/haynes-pro.category';
import { HaynesProService }            from '../haynes-pro.service';
import { HaynesProTechnicalDataModel } from '../typings/haynes-pro.technical-data';
import { HaynesProVehicleInfoModel }   from '../typings/haynes-pro.vehicle-info';
import { JsonService }                 from '../../core/services/json.service';
import { MessagesService }             from '../../messages/messages.service';
import { VehicleModel }                from '../../vehicles/models/vehicle';

@Component({
  selector   : 'wor-haynes-pro-diagnostic-tool',
  template: require('./haynes-pro.diagnostic-tool.component.html')
})
export class HaynesProDiagnosticToolComponent implements OnDestroy, OnInit {
  private subscriptionStatusSubscription : Subscription;

  public activeTab : any = 0;

  /**
   * The categories should be static because they won't change
   * and if we update them, all the tabs will reload causing
   * extra calls and loss of progress. However, we need the
   * status of each category to be dynamic and update as the
   * user purchases sections. So we will store both the
   * static categories and the live ones. The live ones will be
   * updated according to the subscription status observable.
   */
  public liveCategories   : Array<HaynesProCategoryModel>;
  public staticCategories : Array<HaynesProCategoryModel>;
  public vehicleInfo      : HaynesProVehicleInfoModel;

  @Input() variants       : Array<HaynesProVehicleInfoModel>;
  @Input() vehicle        : VehicleModel;
  @Input() technicalData  : HaynesProTechnicalDataModel;

  constructor (
    public activeModal       : NgbActiveModal,
    @Inject(forwardRef(() => HaynesProService)) public haynesProService  : HaynesProService,
    private jsonService      : JsonService,
    private messagesService  : MessagesService,
    public  translateService : TranslateService
  ) {}

  ngOnDestroy () : void {


    this.subscriptionStatusSubscription.unsubscribe();


  }

  ngOnInit () : void {


    this.init();


  }

  getCategoryTitle ( category : any ): string {
    switch (category.title) {

      case 'Servicing':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.SERVICING');
      case 'Repairs':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.REPAIRS');
      case 'Electronic':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.ELECTRONICS');
      case 'Smart Pack':
        return this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.HAYNES_PRO.SMART_PACK');

    }
  }

  init () : void {
    this.liveCategories   = this.jsonService.copy(this.technicalData.categories);
    this.staticCategories = this.jsonService.copy(this.technicalData.categories);
    this.vehicleInfo      = this.technicalData.vehicle_info;

    if (this.subscriptionStatusSubscription) {


      this.subscriptionStatusSubscription.unsubscribe();


    }

    this.subscriptionStatusSubscription = this.haynesProService.subscriptionStatus$.subscribe(() => {
      this.haynesProService.getVehicleTechnicalData(this.vehicle)
      .then(( technicalData : HaynesProTechnicalDataModel ) => {
        this.liveCategories = this.jsonService.copy(technicalData.categories);
      })
      .catch((err)=>{
        this.messagesService.error(err);
      });
    });
  }

  switchVariant () : void {
    this.haynesProService.selectVehicleVariant(this.vehicle, this.variants)
    .then(( vehicle : VehicleModel ) => {
      this.vehicle = vehicle;

      this.haynesProService.getVehicleTechnicalData(this.vehicle)
      .then(( technicalData : HaynesProTechnicalDataModel ) => {
        this.technicalData = technicalData;

        this.init();
      });
    });
  }
}
